import app from '../../scripts/app';
const templates = require.context('./templates', true, /\.tpl\.jade$/);
templates.keys().map(templates);

app.directive('cianAfHeaderPromo', [
  () => {
    return {
      scope: {},
      bindToController: {},
      controllerAs: 'headerPromoCtrl',
      template: '<ng-include src="headerPromoCtrl.getTemplateUrl()"/>',
      controller(headerPromoService) {
        'ngInject';

        this.promoImagePath = require('../../resources/assets/images/header-promo/info.svg');

        this.getTemplateUrl = function () {
          return 'blocks/header-promo/templates/' + headerPromoService.getType() + '.tpl.jade';
        };

        this.handleCloseButtonClick = () => {
          headerPromoService.isVisible = false;
        };
      },
    };
  },
]);
